import { assets } from '@/ui/assets'
import { Skeleton } from '@/ui/atoms/skeleton/Skeleton'
import { testIds } from '@/ui/utils/testIds'
import { cn } from '@/ui/utils/style'
import { LinkButton } from '@/ui/atoms/button/Button'
import { paths } from '@/config/paths'
import { useUserPoints } from '@/domain/merkl/user-points/useUserPoints'
import { useAccount } from '@/domain/hooks/useAccount'
import { useChainId } from 'wagmi'
import { SPK_MOCK_TOKEN } from '@/domain/types/Token'

interface AirdropBadgeLayoutProps {
  isLoading?: boolean
  className?: string
  closeMobileMenu?: () => void
}

export function AirdropBadgeLayout({ isLoading, className, closeMobileMenu }: AirdropBadgeLayoutProps) {
  const account = useAccount()
  const chainId = useChainId()
  const { data: userPoints } = useUserPoints({ account, chainId })
  return (
    <div>
      <LinkButton
        href={paths.points}
        className={cn('gradient-border px-[.6rem] py-[.3rem]', className)}
        data-testid={testIds.navbar.airdropBadge}
        onClick={closeMobileMenu}
      >
        <span className="flex items-center justify-center gap-1.5">
          <img src={assets.hypurrPaw} className="block h-7 pt-1" />
          {isLoading ? (
            <Skeleton className="h-4 w-12" />
          ) : (
            <span className="flex items-center font-bold text-white text-xs" data-chromatic="ignore">
              {userPoints?.points ? SPK_MOCK_TOKEN.format(userPoints.points, { style: 'compact' }) : ''} Points
            </span>
          )}
        </span>
      </LinkButton>
    </div>
  )
}
